import useAPI from "../../helperHooks/useAPI";
import { EligibilityService } from "../../services/eligibilityService";

const useWepOTP = () => {
  const { callAPI: generateWepOtp, ...wepOtpData } = useAPI(
    EligibilityService.wepGenerateOtp
  );

  const { callAPI: verifyWepOtp, ...verifyOtpData } = useAPI(
    EligibilityService.wepVerifyOtp
  );

  return {
    generateWepOtp,
    verifyWepOtp,
    wepOtpData,
    verifyOtpData
  };
};

export default useWepOTP;
